/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from 'reselect';
import { RootState } from 'stores/reducers';
import { range } from 'utils/range';

export const getSearch = createSelector(
  ({ router }: RootState) => router,
  ({ search }) => search
);

export const getPathname = (state: RootState) => state.router.path;

export const getHost = ({ host }: any) => host;
export const getBaseUrl = createSelector(
  getHost,
  getPathname,
  (host, pathname) => `https://${host}${pathname}`
);

export const getHostname = createSelector(getHost, host => host?.replace(/:[0-9]+/, ''));

export const getDomain = createSelector(getHostname, hostname => {
  let result = '';
  if (hostname) {
    const localhost = 'localhost';
    const separator = '.';
    const start = hostname.indexOf(separator);

    const isIpAddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/g.test(
      hostname
    );

    if (isIpAddress) {
      return hostname;
    }

    if (hostname.endsWith(localhost)) {
      const splitted = hostname.split('.');

      return splitted[splitted.length - 1];
    }

    if (start !== -1) {
      const split = hostname.split(separator);

      result = hostname
        .split(separator)
        .slice(split.length - 2)
        .join(separator);
    }
  }

  return result;
});

export const getRegion = createSelector(getHostname, getDomain, (hostname, domain) => {
  const allFsStands = range(20).map(index => `fs${index}`);
  const defenetlyNotARegion = [
    ...allFsStands,
    'ux',
    'aem-pprod',
    'aem',
    'localhost',
    'leroymerlin',
    'lemanapro',
  ];

  if (
    ['adeo.com', 'leroymerlin.ru', 'localhost', 'lemanapro.ru'].some(
      matchingDomain => domain === matchingDomain
    )
  ) {
    const [maybeRegion] = hostname.split('.');

    if (!defenetlyNotARegion.includes(maybeRegion)) {
      return maybeRegion;
    }
  }

  return '';
});

export const getQueryParams = createSelector(getSearch, (params: string) =>
  params.length > 0
    ? params
        .replace('?', '')
        .split('&')
        .map(param => {
          const [name, value] = param.split('=');
          return { [name]: value };
        })
    : null
);

export const getHiddenElementsParam = createSelector(getQueryParams, params => {
  const hiddenParam = params?.find(param => 'hiddenElements' in param);
  return hiddenParam?.hiddenElements;
});
